const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMute(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31.92 34.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M23,1.92a1.39,1.39,0,0,0-1.35.14l-12.42,9H3.28A2.46,2.46,0,0,0,.72,13.36V22.6a2.44,2.44,0,0,0,2.56,2.3H9.21l12.41,9a1.38,1.38,0,0,0,.8.25A1.55,1.55,0,0,0,23,34a1.16,1.16,0,0,0,.72-1V3A1.16,1.16,0,0,0,23,1.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.68,34.43a1.43,1.43,0,0,1-2,.11L.47,33.47a1.43,1.43,0,0,1-.1-2L28.25.47a1.42,1.42,0,0,1,2-.1l1.19,1.07a1.41,1.41,0,0,1,.11,2Z",
    style: {
      fill: "#fb7558"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMute);
export default __webpack_public_path__ + "static/media/mute.0548420f9e3d426999abef30291720f1.svg";
export { ForwardRef as ReactComponent };